import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import PostCard from '../components/PostCard';
import Sidebar from '../components/Sidebar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CategoryPage = () => {
  const { slug } = useParams();
  const [posts, setPosts] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [popularPosts, setPopularPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [slug]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [postsRes, categoriesRes, popularRes] = await Promise.all([
        axios.get(`${API}/posts?category=${slug}`),
        axios.get(`${API}/categories`),
        axios.get(`${API}/posts/popular?limit=5`),
      ]);

      setPosts(postsRes.data);
      setCategories(categoriesRes.data);
      setPopularPosts(popularRes.data);

      const category = categoriesRes.data.find(cat => cat.slug === slug);
      setCategoryName(category?.name || slug);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl font-bold" data-testid="loading-indicator">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12 py-16 sm:py-24">
        <div className="mb-12">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-primary" data-testid="category-label">
            Category
          </span>
          <h1 className="text-5xl sm:text-6xl tracking-tight leading-none font-black mt-4" data-testid="category-title">
            {categoryName}
          </h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          <div className="lg:col-span-2" data-testid="category-posts-section">
            {posts.length > 0 ? (
              <div className="space-y-12">
                {posts.map((post) => (
                  <PostCard key={post.id} post={post} />
                ))}
              </div>
            ) : (
              <p className="text-muted-foreground" data-testid="no-posts-message">No posts found in this category.</p>
            )}
          </div>

          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <Sidebar popularPosts={popularPosts} categories={categories} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPage;
